import * as Enumerable from 'linq';
import { catchError, lastValueFrom, map, Observable, of } from 'rxjs';

import { Injectable } from '@angular/core';
import { Allocation, AllocationCard, AllocationStatus, Source } from '@jms/model';
import { AllocationEventData } from '@jms/shared/module.scheduling.allocations.pro';
import { AppointmentContext, AppointmentServiceBase } from '@jms/ui/ui.appointments';

@Injectable()
export class ContractorAppointmentsService extends AppointmentServiceBase {

    public readonly source = Source.ContractorPortal;
    public readonly api = 'https://__tenant__/api/portal/contractor/scheduler/allocations';
    private _canAdd: boolean;
    private _canEdit: boolean;
    private _canDelete: boolean;

    constructor() {
        super();
    }

    override getAll(params: { jobId: string, workOrderId: string }): Observable<Allocation[]> {

        return this.http.get<Allocation[]>(`${this.api}/${params.jobId}/${params.workOrderId}`)
            .pipe(
                map(x => x),
                catchError(() => of([]))
            );
    }

    override create(allocation: Allocation, context: AppointmentContext): Observable<Allocation[]> {

        const enrichAllocation = this.enrichAllocation(allocation, context);

        return this.http.post<Allocation[]>(`${this.api}`, enrichAllocation)
            .pipe(
                map(res => res),
                catchError((error) => {
                    this._error$.next(error?.error?.message ?? "An unknown error occurred")
                    return of(null);
                })
            );

    }

    override getForPeriod(start: Date, end: Date, selected?: Allocation): Promise<AllocationEventData[]> {

        const queryParams = {
            start: start.toISOString(),
            end: end.toISOString()
        };

        const data = this.http.get<AllocationCard[]>(`${this.api}`, { params: queryParams })
            .pipe(
                map(allocations =>
                    Enumerable.from(allocations)
                        .select(c => {

                            const isSelected = c._id === selected?._id;
                            const editable = isSelected;

                            const data: AllocationEventData = {
                                id: c._id,
                                title: c.status === AllocationStatus.Overhead
                                    ? c?.overhead?.name
                                    : c?.workOrder?.name,
                                start: c.startDate,
                                end: c.endDate,
                                resourceId: c?.contractorResource?._id,
                                resourceEditable: editable,
                                // resourceEditable: c?.resource?.type === ContactType.Subcontractor
                                //     ? false
                                //     : true,
                                editable: editable,
                                selected: isSelected,
                                entity: c
                            };

                            return data;
                        })
                        .toArray()
                ),
                catchError(error => {
                    return of([]);
                })
            );

        return lastValueFrom(data);
    }


    private enrichAllocation(allocation: Allocation, context: AppointmentContext): Allocation {

        const { workOrder: { jobId, jobNumber, _id, workOrderNumber } } = context;


        const enrichAllocation = {
            ...allocation,
            source: this.source,
            job: {
                _id: jobId,
                name: jobNumber
            },
            workOrder: {
                _id: _id,
                name: workOrderNumber
            },
            // site: {
            //     _id: site?._id,
            //     address: site?.address,
            //     contactName: site?.contactName,
            //     contactPhone: site?.contactPhone
            // },
        }

        return enrichAllocation;
    }

    public setCanAdd(canAdd: boolean) {
        this._canAdd = canAdd;
    }

    override canAdd(): boolean {
        return this._canAdd;
    }

    public setCanEdit(canEdit: boolean) {
        this._canEdit = canEdit;
    }

    override canEdit(item: Allocation): boolean {
        return this._canEdit;
    }

    public setCanDelete(canDelete: boolean) {
        this._canDelete = canDelete;
    }

    override canDelete(item: Allocation): boolean {
        return this._canDelete;
    }
}